import { withHydrate } from '@relay/react/hooks';
import { AlgoliaIndexes, getAlgoliaIndex } from '@core/algolia';
import { getNavigationId } from '@helpers/navigationTitle';
import withRedux from '@helpers/withRedux';
import { withMotion } from '@hoc/withMotion';
import useAlgoliaEvents from '@hooks/useAlgoliaEvents';
import ProductDetailsContent from '@stories/Components/ProductDetail/ProductDetailsContent/ProductDetailsContent';
import { Grid } from '@stories/Settings/Grids/Grid.styles';
import ProductMediaLayout from '@stories/Widgets/ProductDetail/ProductMediaLayout/ProductMediaLayout';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useProductAssets } from './ProductToolOverview.api';
import { ProductToolOverviewStyles as S } from './ProductToolOverview.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ProductToolOverview = props => {
  useProductAssets();
  const {
    aaLoaded,
    convertedObjectIDs,
    convertedObjectIDsAfterSearch,
    getAlgoliaQueryId,
    clearAlgoliaQueryId
  } = useAlgoliaEvents();
  useEffect(() => {
    if (!aaLoaded) {
      return;
    }
    const queryId = getAlgoliaQueryId();
    if (!queryId) {
      convertedObjectIDs(getAlgoliaIndex(AlgoliaIndexes.products, props.pageContext.documentCulture, props.algoliaEnvironmentPrefix), [props.product.agilityId.toString()]);
    } else {
      convertedObjectIDsAfterSearch(getAlgoliaIndex(AlgoliaIndexes.products, props.pageContext.documentCulture, props.algoliaEnvironmentPrefix), queryId, [props.product.agilityId.toString()]);
      clearAlgoliaQueryId();
    }
  }, [aaLoaded]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Helmet, {
      children: /*#__PURE__*/_jsx("meta", {
        name: "format-detection",
        content: "telephone=no"
      })
    }), /*#__PURE__*/_jsx(S.Container, {
      id: getNavigationId(props.navigationTitle),
      "data-navigation-title": props.navigationTitle,
      "data-navigation-id": getNavigationId(props.navigationTitle),
      children: /*#__PURE__*/_jsxs(Grid.Default, {
        children: [/*#__PURE__*/_jsx(S.Media, {
          children: /*#__PURE__*/_jsx(ProductMediaLayout, {
            translations: props.translations
          })
        }), /*#__PURE__*/_jsx(S.Content, {
          children: /*#__PURE__*/_jsx(ProductDetailsContent, {
            pageContext: props.pageContext,
            popupData: props.popupData,
            product: props.product,
            technologies: props.technologies,
            customIcons: props.customIcons,
            translations: props.translations,
            storeLocatorUrl: props.storeLocatorUrl,
            storeLocatorText: props.storeLocatorText,
            variantSelectionLayout: props.variantSelectionLayout,
            showAR: props.showAR,
            rangeCta: props.rangeCta,
            formCta: props.formCta,
            recyclingIcon: props.recyclingIcon,
            recyclingIconLink: props.recyclingIconLink,
            showThreekitConfigurator: props.showThreekitConfigurator,
            warrantyLogo: props.warrantyLogo,
            standardsUrl: props.standardsUrl,
            featuresUrl: props.featuresUrl,
            repairabilityIndexImageUrl: props.repairabilityIndexImageUrl,
            repairabilityIndexLinkUrl: props.repairabilityIndexLinkUrl,
            c2bAction: props.c2bAction
          })
        })]
      })
    })]
  });
};
export const clientConfig = {
  hydrate: 'always'
};
export default withHydrate(withRedux(withMotion(ProductToolOverview)), 'ProductToolOverview', 'hybrid');
